var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "judge_question" }, [
    _c("div", { staticClass: "question_title" }, [
      _c("span", [
        _vm._v(
          _vm._s(
            _vm.questionData.sectionName === undefined
              ? ""
              : _vm.questionData.sectionName
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "(" +
            _vm._s(
              _vm.questionData.sectionPrompt +
                "  本题" +
                _vm.questionData.score +
                "分。"
            ) +
            ")"
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "title" }, [
      _vm.questionData.questionContent
        ? _c("div", {
            staticClass: "editorShowArea ql-editor title_one",
            domProps: { innerHTML: _vm._s(_vm.questionData.questionContent) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h3", {
        staticClass: "editorShowArea ql-editor",
        staticStyle: { overflow: "auto" },
        domProps: {
          innerHTML: _vm._s(_vm.questionData.questionDto.questionContent)
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "select" }, [
      _c("i", {
        staticClass: "el-icon-circle-check",
        class: { active: _vm.num === 0 },
        on: {
          click: function($event) {
            return _vm.select(0)
          }
        }
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "el-icon-circle-close",
        class: { active: _vm.num === 1 },
        staticStyle: { "margin-left": "60px" },
        on: {
          click: function($event) {
            return _vm.select(1)
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23756c3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23756c3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testComponent/judge.vue
// module id = null
// module chunks = 